<script>
  import { ignore } from "../../Common/tools";
  import { onMount, onDestroy } from "svelte";
  import QuizFieldOptionSettings from "./QuizFieldOptionSettings.svelte";
  import {External, M} from "../../external";

  export let field,
    steps = [],
    onChange = ignore;

  let sortable, jqSortable;
  let isProperty = false;

  let settings = field.optionSettings || [];
  if (settings.length > field.options.length) {
    settings.splice(
      field.options.length,
      settings.length - field.options.length
    );
    field.optionSettings = settings;
  } else {
    while (settings.length < field.options.length) {
      settings.push({
        score: 0,
        nextStep: "finish"
      });
    }
    field.optionSettings = settings;
  }

  let addOption = () => {
    External.Tools.promptForInput(M.ADD_OPTION, M.ADD_OPTION, "", option => {
      if (field.options.indexOf(option) > -1) {
        // duplicate
        return;
      }
      field.options.push(option);
      field.options = field.options;
      field.optionSettings.push({
        score: 0,
        nextStep: "finish"
      });
      field.optionSettings = field.optionSettings;
      onChange();
    });
  };

  let changeScore = (idx, change) => {
    field.optionSettings[idx].score += change;
    onChange();
  };

  let onDelete = idx => {
    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, () => {
      field.options.splice(idx, 1);
      field.optionSettings.splice(idx, 1);
      field.options = field.options;
      field.optionSettings = field.optionSettings;
      onChange();
    });
  };

  let setOptionValue = (event, idx) => {
    field.options[idx] = event.target.value;
    field.options = field.options;
    onChange();
  };

  let showSettings = idx => {
    External.Tools.showWindow({
      isModal: false,
      title: M.RESIZE_CONTAINER_TITLE,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: "",
      action: {
        onShow: (popup, ui) => {
          new QuizFieldOptionSettings({
            target: popup.getContentArea(),
            props: {
              field: field,
              settings: field.optionSettings[idx] || {},
              steps: steps,
              onChange: onChange
            }
          });
        }
      }
    });
  };

  let refreshFieldOptions = () => {
    if (field.property) {
      let property = External.getById(External.Website.crmProperties, field.property);
      if (property && property.value && property.value.length > 0) {
        let currentOptions = field.options || [];
        let optionSettings = field.optionSettings || [];

        // remove all options that are not part of the property
        property.value.forEach(option => {
          if (currentOptions.indexOf(option) === -1) {
            currentOptions.push(option);
          }
        });

        // add any missing option to the field
        for (let idx = 0; idx < currentOptions.length; ++idx) {
          let option = currentOptions[idx];
          if (property.value.indexOf(option) === -1) {
            currentOptions.splice(idx--, 1);
          }
        }
        if (optionSettings.length != currentOptions.length) {
          if (optionSettings.length > currentOptions.length) {
            optionSettings.splice(
              currentOptions.length,
              optionSettings.length - currentOptions.length
            );
          } else {
            for (
              let idx = optionSettings.length;
              idx < currentOptions.length;
              ++idx
            ) {
              optionSettings.push({ score: 0 });
            }
          }
        }

        field.options = currentOptions;
        field.optionSettings = optionSettings;
      }
    }
  };

  let editProperty = () => {
    let property = External.getById(External.Website.crmProperties, field.property);
    External.UITools.editProperty(property, () => {
      refreshFieldOptions();
      onChange();
    });
  };

  onMount(() => {
    refreshFieldOptions();
    isProperty = false;
    if (field.property) {
      let prop = External.getById(External.Website.crmProperties, field.property);
      isProperty = prop && prop.type === "LIST";
    }
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: ".option-wrapper",
      handle: ".move-icon",
      containment: "parent",
      tolerance: "pointer",
      axis: "y",
      start: (event, ui) => {
        ui.item.data("idx", ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data("idx") || 0;
        if (newIdx != oldIdx) {
          let option = field.options[oldIdx];
          field.options.splice(oldIdx, 1);
          field.options.splice(newIdx, 0, option);
          field.options = field.options;

          let settings = field.optionSettings[oldIdx];
          field.optionSettings.splice(oldIdx, 1);
          field.optionSettings.splice(newIdx, 0, settings);
          field.optionSettings = field.optionSettings;
          onChange();
        }
      }
    });
  });

  onDestroy(function() {
    jqSortable.sortable("destroy");
    jqSortable = null;
  });
</script>

<div class="options-wrapper col20 f-left" bind:this={sortable}>
  {#each field.options as option, idx (option)}
    <div class="option-wrapper field col20 f-left flex align-center">
      <span
        class="move-icon button-tooltip ui-sortable-handle"
        data-tooltip="simpleMove" />
      <input
        type="text"
        value={option}
        readonly={isProperty}
        on:blur={(event) => setOptionValue(event, idx)} />
      <div class="buttons-wrapper flex align-center">
        <div class="number-selector f-left flex align-center">
          <span class="f-left mr-5 roboto">{M.SCORE}</span>
          <a
            class="number-pad"
            style="line-height: 28px;"
            on:click={() => changeScore(idx, -1)}>
            -
          </a>
          <input
            type="number"
            min="0"
            max="999"
            on:blur={onChange}
            bind:value={field.optionSettings[idx].score} />
          <a class="number-pad" on:click={() => changeScore(idx, 1)}>+</a>
        </div>
        <a
          on:click={() => showSettings(idx)}
          data-tooltip="settings"
          class="delete delete-icon modify button-tooltip light-gray-icon
          circle-effect mr-5">
          <i class="material-icons-outlined">settings</i>
        </a>
        {#if !isProperty}
          <a
            data-tooltip="simpleDelete"
            class="delete delete-icon modify button-tooltip light-gray-icon
            circle-effect"
            on:click={() => onDelete(idx)}>
            <i class="material-icons-outlined">delete</i>
          </a>
        {/if}
      </div>
    </div>
  {/each}
  {#if !isProperty}
    <a class="add-option blue" on:click={addOption}>{M.ADD_OPTION}</a>
  {:else}
    <span class="col20 f-left mt-10 mb-10" on:click={editProperty}>
      {@html M.EDIT_CRM_PROPERTY_OPTIONS_DESC}
    </span>
  {/if}
</div>
